<template>  
    <div >
    <div v-if="loading" class="loader">
        <v-progress-circular
            :size="100"
            :width="8"
            color="#6FB793"
            indeterminate
        ></v-progress-circular>
    </div>

    <div :key="querykey" v-else class="query m-10">
        <div class="flex query-header">
            <div class="flex query-header-text">
                <p :class="{'active': allQactive}"  @click="handleAllQueryclicked()">All queries</p>
                <p :class="{'active': respondedQactive}" @click="handleRespondedClicked()">Responded queries</p>
            </div>

            <!-- select predefined comment  -->
            <template>
                <v-dialog v-model="dialog" max-width="0" overlay-opacity="0">
                    <template v-slot:activator="{ on, attrs }">
                        <button v-bind="attrs" v-on="on" class="add-comment-btn">
                            Add comment to selected  
                            <v-icon size="20" class="downarrow-icon"> mdi-chevron-down</v-icon>
                        </button>
                    </template>
                    <v-card class="addcomment-con">
                        <add-comment @sendbulkmsgclicked = "handlebulkmsgclicked"/>
                    </v-card>
                </v-dialog>
            </template>  
        </div>

        <!-- add filter section  -->
        <div class="flex filter-con">
            <div class="flex filters"> 
                <v-checkbox label="Select all" class="checkbox" hide-details color="success" v-model="checkbox"/>
                <span v-if="startdatePresent" class="datecon">0</span>

                <!-- Start date filter  -->
                <div class="qtypemenu startdate">
                <v-menu :value="startDateVal" :close-on-content-click="false" offset-y offset-x right>
                    <template v-slot:activator="{ on, attrs }">
                        <p @click="startDateVal=!startDateVal" v-bind="attrs" v-on="on">
                            <span></span>
                            Start date <v-icon> mdi-chevron-down </v-icon></p>
                    </template>
                    <div v-if="startDateVal">
                        <startdatefilter
                            :key = "startDateVal"
                            @cleardaterange="clearStartDateFilters"
                            @applydaterange = "applyStateDateFilter"                    
                        />
                    </div>
                </v-menu>
                </div> 

                <!-- End date filter  -->
                <span v-if="enddatePresent" class="datecon">0</span>
                <div class="qtypemenu enddate">
                <v-menu :value="endDateVal" :disabled="!startdatePresent" :close-on-content-click="false" offset-y offset-x right>
                    <template v-slot:activator="{ on, attrs }">
                        <p @click="endDateVal=!endDateVal" v-bind="attrs" v-on="on" class="enddatetext" :class="{'active': !startdatePresent}">
                            End date <v-icon> mdi-chevron-down </v-icon>
                        </p>
                    </template>
                    <div v-if="endDateVal">
                    <enddatefilter 
                        :key = "endDateVal"
                        @cleardaterange="clearEndDateFilter"
                        @applydaterange = "applyEndDateFilter"
                    />
                    </div>
                </v-menu>
                </div>                 

                <!-- location filter  -->
                <div v-if="!respondedQClicked" class="qtypemenu">   
                <v-menu :eager="true" :value="locationVal" :close-on-content-click="false" offset-y offset-x right>
                    <template v-slot:activator="{ on, attrs }">
                        <p @click="locationVal = !locationVal" v-bind="attrs" v-on="on">
                            <span v-if="locationno !== 0" class="selectedno">{{locationno}}</span>
                            Location 
                            <v-icon> mdi-chevron-down </v-icon></p>
                    </template>
                    
                    <div v-if="locationVal">
                        <locations 
                            :key = "locationVal"
                            :locationDoneClicked = "locationDoneClicked"
                            :locationclicked = "locationVal"
                            @clearlocation="cleartLocationFilter" 
                            @applylocation="applylocationFilter"
                        />
                    </div>
                    <div class="location-con">
                    </div>
                </v-menu> 
                </div> 

                <!-- Query type filter  -->
                <div v-if="!respondedQClicked" class="qtypemenu">
                <v-menu :value="qtypeVal" :close-on-content-click="false" offset-y offset-x right>
                    <template v-slot:activator="{ on, attrs }">
                        <p @click="qtypeVal = !qtypeVal" v-bind="attrs" v-on="on">
                            <span v-if="querytypeno !== 0" class="selectedno">{{querytypeno}}</span>
                                Query type
                            <v-icon> mdi-chevron-down </v-icon>
                        </p>
                    </template>
                    <div v-if="qtypeVal">
                        <queryType
                            :key = "qtypeVal"
                            @clearquerytype="clearquerytype"
                            @applyquerytype = "applyquerytype"
                            @croptypeclicked = "croptypeclicked"
                        />
                    </div>
                </v-menu>
                </div>

                <!--  -->
                <!-- crop type filter  -->
                <div v-if="querytypeno !== 0">
                <div v-if="showCrops  && !respondedQClicked" class="qtypemenu">
                <v-menu :value="cropVal"  :close-on-content-click="false" offset-y offset-x right>
                    <template v-slot:activator="{ on, attrs }">
                        <p @click="cropVal = !cropVal" v-bind="attrs" v-on="on">
                            <span v-if="cropno !== 0" class="selectedno">{{cropno}}</span>Crops
                            <v-icon> mdi-chevron-down </v-icon></p>
                    </template>
                    <div v-if="cropVal">
                        <crops
                            :key = cropVal
                            @applycrops = "applycrops"
                            @clearcrops = "clearcrops"
                        />
                    </div>
                </v-menu>
                </div>    
                </div>            
            </div>

            <!-- filter button section  -->
            <div class="flex button-con"> 
                
                <p v-if="!datepresent" class="reset-btn" style="color: #98C39A">Reset all filters</p>
                <p v-else @click="resetAllFilter" class="reset-btn" style="color: #1D8D56">Reset all filters</p>
                <v-btn @click="applyfilter" :disabled="disableApplybtn" elevation="0" class="white--text apply-btn" color="#1D8D56">
                    Apply filter
                </v-btn>
            </div>
        </div>
        <div @scroll="onScroll" v-if="isdata" class="query-card_con">
            <query-card :key="keyforquery" :farmerQueries="farmerQueries" :checkboxModel="checkbox" :removeall="removeall" @checkclicked="checkbox = false"/>
            <div v-if="downloader" class="downloader">
                <p>Loading more</p>
                <v-progress-circular
                    :size="35"
                    :width="4"
                    color="#6FB793"
                    indeterminate
                />
            </div>
        </div>
        <div class="addmsg" v-else-if="!isdata">
            <div v-if="!apicalled">
                <p v-if="!respondedQClicked">Please add date range and location</p>
                <p v-else>Please add date range</p>
            </div>
                <p v-else>No data present.</p>
        </div>
    </div>
    </div>
</template>


<script>
import queryCard from "./components/query-card.vue"
import addComment from "./components/addcomment.vue"
import pagination from "../Common/pagination.vue"
import API_URL from "../../../helpers/apiUrls";
import locations from "./components/locationfilter.vue"
import startdatefilter from "./components/startdatefilter"
import enddatefilter from "./components/enddatefilter"
import queryType from "./components/queryType.vue";
import crops from "./components/crops.vue"
import { mapActions } from "vuex";
import infiniteScroll from "../Common/infinite-scroll.vue";
import accessToken from "../../../helpers/accessToken";

export default {
    ...mapActions(["queryStore", "removealltopics", "GET_SELECTED_TOPICS", "GET_STATE_ID"]),
    name:'query',
    data(){
        return{
            isActive : true, 
            allQactive: true,
            respondedQactive : false,
            checkbox: false,
            filterdialog : false,
            dialog: false,
            selectAll: false,
            farmerQueries : [],
            loading : false,
            daterangeVal : false,
            startDateVal : false,
            endDateVal : false,
            startdatePresent : false,
            enddatePresent : false,

            locationVal : false,
            isdata : false,
            qtypeVal : false,
            cropVal : false,
            showCrops : false,
            apicalled : false,
            querytypeno : "",
            cropno : "",
            locationno : "",
            datepresent : false,
            offset : 0,
            formDataPerPage : 10,
            totalcount : 0,
            downloader : false,
            getapicalled : false,

            respondedQClicked : false,
            locationstoredata : "",
            startdate : "",
            enddate : "",
            qtypestoredata : "",   
            selectedCropIds : "", 
            disableApplybtn : true,

            locationDoneClicked : false,
            removeall : false,
            keyforquery : false,
            pageno : 1,
            respondedcount : 0,
            querykey : false,
            cropshow : true,
        }
    },
    components: {
        "query-card": queryCard,
        "add-comment": addComment,
        "pagination": pagination,
        "locations" : locations,
        "queryType" : queryType,
        "crops" : crops,
        "infinite-scroll" : infiniteScroll,
        "startdatefilter" : startdatefilter,
        "enddatefilter" : enddatefilter
    },

    mounted(){
        console.log("------QUERY PAGE MOUNTED-----");
        // get data from store if presemt on mounted 
        this.$store.dispatch('queryStore/removestateid');
        this.$store.dispatch('queryStore/removeallcrops');
        this.$store.dispatch('queryStore/removealltopics');
        this.$store.dispatch('queryStore/removestartdate');
        this.$store.dispatch('queryStore/removeenddate');
        this.getQTypeStoreData();
        this.getlocationStoreDate(); 
        this.getDateStoreData();
        this.getCropsStoreData(); 
        this.datepresent = false;
    },

    watch:{
        qtypeVal:function(){
            console.log("QTYPEVAL--->", this.qtypeVal);
        }
    },

    methods:{
        handlebulkmsgclicked(){
            console.log("BULK MESSAGE CLICKED");
            this.keyforquery = !this.keyforquery
        },

        
        // for location
        cleartLocationFilter(){
            // this.locationVal = false;
            this.disableApplybtn = true;
            this.locationno = 0;
            this.getlocationStoreDate();
        },
        applylocationFilter(){
            this.locationVal = false;
            this.offset = 0;
            this.getlocationStoreDate(); 
            this.locationDoneClicked = true;         
        },

        // for date range fiter ------------
         clearStartDateFilters(){                                       //for start date clear button in calendar
            // this.daterangeVal = false;
            this.datepresent = false;
            this.disableApplybtn = true;
            // this.farmerQueries = [];
            this.offset = 0;
            this.getDateStoreData();
            this.startdatePresent=false;
            
            if(this.enddatePresent){                       //if end date is present then reset that also
            this.$store.dispatch('queryStore/removeenddate');
            this.clearEndDateFilter();
            }       
        },
       
         clearEndDateFilter(){                                   //for end date clear button in calendar
            // this.daterangeVal = false;
            this.datepresent = false;
            this.disableApplybtn = true;
            // this.farmerQueries = [];
            this.offset = 0;
            this.getDateStoreData();
            this.enddatePresent=false;
            

        
            
            
        },

        // apply when donw button cliced in start date filter
        applyStateDateFilter(){
            this.startDateVal = false;
            this.offset = 0;
            this.getDateStoreData();

            if(this.enddate){
          
            console.log("a", new Date(this.enddate));
             console.log("a", new Date(this.startdate));

             if(new Date(this.enddate) < new Date(this.startdate)){
            this.enddatePresent=false;
            this.$store.dispatch('queryStore/removeenddate');
            this.clearEndDateFilter();
            // this.startdatePresent=false;
             }


            }

            
        },

        applyEndDateFilter(){
            this.endDateVal = false;
            this.offset = 0;
            this.getDateStoreData();
        },

        // query type -------------
        clearquerytype(){
            // this.qtypeVal = false;
            this.cropno = 0; 
            this.showCrops = false;
            this.getQTypeStoreData();
            this.getCropsStoreData();
        },
        applyquerytype(){
            this.qtypeVal = false;
            this.offset = 0;
            this.getQTypeStoreData();
        },

        // for crops filter -------------
        applycrops(){
            this.cropVal = false;
            this.offset = 0;
            this.getCropsStoreData();
        },
        clearcrops(){
            // this.cropVal = false;
            this.getCropsStoreData();
        },


        // will call when type is clicked in query type list 
        croptypeclicked(flag){
            this.cropVal = false;
            this.showCrops = flag;
            if(this.showCrops === false){
                console.log("ekrbguegbrengierhreinjk");
                this.cropno = 0
            }
        },


        // get selected query type from store
        getQTypeStoreData(){
            this.qtypestoredata = this.$store.getters["queryStore/GET_SELECTED_TOPICS"];
            this.querytypeno = this.qtypestoredata.length;
            console.log("QUERY TYPE NO", this.querytypeno,this.qtypestoredata,this.qtypestoredata);

            if(this.querytypeno > 9){
                this.querytypeno = "9+"
            }
            console.log("QUERY TYPE STORE DATA -->", this.qtypestoredata);
        },

        // get selected locations from store
        getlocationStoreDate(){
            this.locationstoredata = this.$store.getters['queryStore/GET_STATE_ID'];
            this.locationno = this.locationstoredata.length;

            // activate apply btn if date range and location is selected
            if(this.locationno && this.datepresent || this.respondedQClicked && this.datepresent){
                this.disableApplybtn = false;
            }
            if(this.locationno > 9){
                this.locationno = "9+"
            }
            console.log("LOCATION STORE DATA -->", this.locationstoredata);
        },

        // get selected date range from store
        getDateStoreData(){
            const storeStartdate = this.$store.getters['queryStore/GET_STARTDATE'];
            const storeEnddate = this.$store.getters['queryStore/GET_ENDDATE'];

            console.log("DATES STORE DATA -->", storeStartdate, storeEnddate);

            this.startdate = storeStartdate.stateid
            this.enddate = storeEnddate.stateid
            if(this.startdate){
                this.startdatePresent = true;
            } 
            if(this.enddate){
                this.enddatePresent = true;
            }

            if(this.startdate && this.enddate){
                this.datepresent = true;
            }  
            // activate apply btn if date range and location is selected
            if(this.locationno && this.datepresent || this.respondedQClicked && this.datepresent){
                this.disableApplybtn = false;
            }            
            
            console.log("STORE DATE QUERY -->", this.startdate, this.enddate);
        },


        // get selected crops from query
        getCropsStoreData(){
            this.selectedCropIds = this.$store.getters["queryStore/GET_SELECTED_CROPS"];
            this.cropno = this.selectedCropIds.length
            // if(this.cropno === 0){
            //     this.showCrops = false;
            // }

            if(this.cropno > 9){
                this.cropno = "9+"
            }
            console.log("STORE DATA", this.selectedCropIds);             
        },

        handleAllQueryclicked(){
            this.allQactive = true;
            this.respondedQactive = false;
            this.respondedQClicked = false;
            this.farmerQueries = []
            this.datepresent = false;
            this.startdatePresent = false;
            this.enddatePresent = false;
            this.apicalled = false;
            this.isdata = false;
            this.disableApplybtn = true;

            this.cropVal = false;
            this.qtypeVal = false;
            this.locationVal = false;
            this.daterangeVal = false;
            this.startDateVal = false;
            this.endDateVal = false;

            this.$store.dispatch('queryStore/removestateid');
            this.$store.dispatch('queryStore/removeallcrops');
            this.$store.dispatch('queryStore/removealltopics');
            this.$store.dispatch('queryStore/removestartdate');
            this.$store.dispatch('queryStore/removeenddate');

            this.getQTypeStoreData();
            this.getlocationStoreDate();
            this.getDateStoreData();
            this.getCropsStoreData();
        },
        handleRespondedClicked(){
            this.allQactive = false;
            this.respondedQactive = true;
            this.respondedQClicked = true;
            this.apicalled = false;
            this.datepresent = false;
            this.startdatePresent = false;
            this.enddatePresent = false;
            this.disableApplybtn = true;
            this.farmerQueries = [];
            this.isdata = false;

            this.cropVal = false;
            this.qtypeVal = false;
            this.locationVal = false;
            this.daterangeVal = false;
            this.startDateVal = false;
            this.endDateVal = false;

            this.$store.dispatch('queryStore/removestateid');
            this.$store.dispatch('queryStore/removeallcrops');
            this.$store.dispatch('queryStore/removealltopics');
            this.$store.dispatch('queryStore/removestartdate');
            this.$store.dispatch('queryStore/removeenddate');

            this.getQTypeStoreData();
            this.getlocationStoreDate();
            this.getDateStoreData();
            this.getCropsStoreData();
        },
 

        // reset all existing filter and make all the var to intital position
        resetAllFilter(){
            console.log("REMOVE ALL FILTER CLICKED");
            // this.querykey = !this.querykey
            this.$store.dispatch('queryStore/removestartdate');
            this.$store.dispatch('queryStore/removeenddate');
            this.$store.dispatch('queryStore/removestateid');
            this.$store.dispatch('queryStore/removeallcrops');
            this.$store.dispatch('queryStore/removealltopics');
            this.getQTypeStoreData();
            this.getlocationStoreDate();
            this.getDateStoreData();
            this.getCropsStoreData();
            
            this.isdata = false;
            this.apicalled = false;
            this.datepresent = false;
            this.startdatePresent = false;
            this.enddatePresent = false;

            this.cropVal = false;
            this.qtypeVal = false;
            this.checkbox = false;

            this.cropshow  = false;

            this.disableApplybtn = true;
            this.farmerQueries = [];
        }, 


        // apply filter called --------------------------
        applyfilter(){
            console.log("APPLY FILTER CLICKED");
            this.offset = 0;
            this.pageno = 1;
            this.getQTypeStoreData();
            this.getlocationStoreDate();
            this.getDateStoreData();
            this.getCropsStoreData();

            this.farmerQueries = []
            this.cropVal = false;
            this.qtypeVal = false;
            this.locationVal = false;
            this.daterangeVal = false;
            this.startDateVal = false;
            this.endDateVal = false;
            this.loading = true;
            // this.getFarmerQueries();
            if(!this.respondedQClicked){
                this.getFarmerQueries();
            }
            if(this.respondedQClicked){
                this.getRespondedQueries();
            }         
        },

        // make new api call on scroll
        onScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight + 1>= scrollHeight && !this.getapicalled && this.isNextPageAvailable() && this.datepresent && !this.respondedQClicked) {
                this.offset = this.offset + 10;
                this.getFarmerQueries();             
                this.downloader = true;             
            } 
            else if(scrollTop + clientHeight + 1>= scrollHeight && this.respondedQClicked){
                console.log("IN RESPONDED ZONE 098r09890r82390830r83298");
                this.pageno = this.pageno + 1;
                if(this.pageno * 10 <= this.respondedcount){
                    this.getRespondedQueries();
                    this.downloader = true; 
                }
            }
        },

        // check if next page availabel or not based on offset
        isNextPageAvailable() {
            if(this.offset + 10 >= this.totalcount)
                return false;
            return true;
        },

        // get all the responded queries of the brand
        getRespondedQueries(){
            this.isDatapresent = false;
            const successHandler = (response) => {
                this.toggleLoader(false);
                if (response.status === 200) {
                    this.isDatapresent = true;
                    this.respondedcount = response.data.total_count;
                    console.log("RESPONDED ====>", response.data.results);
                    
                    response.data.results.map(item => {
                        this.farmerQueries.push(item)
                    })

                    if(this.farmerQueries.length === 0){
                        this.isdata = false;
                    }  else {
                        this.isdata = true;
                    }
                }

                console.log("FARMER QUERIES  ====>", this.farmerQueries);
                this.getapicalled = false; 
                this.downloader = false;
                this.loading = false;
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                this.loading = false;
                this.downloader = false;
                this.getapicalled = false; 
                this.isDatapresent = true;
                console.log(error);
                this.toggleLoader(false);
            };
            this.business_id = accessToken.getCredentials().brandID;

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                // 'business_id' : this.business_id
            }
            
            this.requestGET(
                `${API_URL.getRespondedQuery}?business_id=${this.business_id}&page=${this.pageno}&data_per_page=${10}&start_date=${this.startdate}&end_date=${this.enddate}`,
                {},
                headers,
                successHandler,
                errorHandler,
            );
        },


        // get all the farmer queries 
        getFarmerQueries(){   
            this.getapicalled = true; 
            this.apicalled = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.totalcount = response.data.total_count
                    console.log("response.data", response.data);

                    response.data.results.map(item => {
                        this.farmerQueries.push(item)
                    })

                    console.log("BEFORE --->", this.farmerQueries);

                    this.farmerQueries = this.farmerQueries.filter(
                        (arr, index, self) => index === self.findIndex((item) => (item.post.id === arr.post.id))         
                    )

                    console.log("AFTER ---->", this.farmerQueries);

                    if(this.farmerQueries.length === 0){
                        this.isdata = false;
                    }  else {
                        this.isdata = true;
                    }
                }
                this.checkbox = false;
                this.getapicalled = false; 
                this.downloader = false;
                this.loading = false;
            };
            console.log("this.locationstoredata --->", this.locationstoredata);
            const data = {
                start_date: this.startdate,
		        end_date: this.enddate,
                states: this.locationstoredata, 
		        limit: this.formDataPerPage,
		        offset: this.offset
            };
            if(this.qtypestoredata.length > 0){
                data.topics = this.qtypestoredata
            }
            if(this.selectedCropIds.length > 0){
                data.crops = this.selectedCropIds
            }

  
            console.log("DATA FOR API", data);
            const errorHandler = (error) => {
                this.loading = false;
                this.downloader = false;
                this.getapicalled = false; 
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };

            this.newRequestPOST(
                `${API_URL.getUserQueries}`,
                data,
                {},
                successHandler,
                errorHandler,
            ); 
        }
    },
}
</script>


<style lang="scss" scoped>
.loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85vh;
}
.filter-con {
    flex-direction: row;
    background-color: #ffffff;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 3px;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    margin-top: 8px;
}
.addmsg{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;

    p{
        color: #5B5B5B;
    }
}
.datecon{
    color: #328A37;
    background-color: #328A37;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    padding: 2px 3.5px;
    font-size: 6px;
    margin-right: 5px; 
    margin-top: 3px;   
}
.selectedno{
    background-color: #328A37;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 2px 6px;
    color: #FFFFFF;
    margin-right: 5px;
}
.downloader{
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 10px;
    height: 30px; 
    // background-color: #FFFFFF;
    width: 100%; 
    margin-top: 20px;

    p{
        margin-bottom: 0px;
        font-size: 1rem;
    }
}
.qtypemenu{
    margin-right: 40px;
}
.filters{
    p{
        margin-bottom: 0px;
        margin-top: 4px;
        font-weight: 500;
        color: #5B5B5B;
        margin-left: 0px;
    }
}

.reset-btn{
    font-weight: 500;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 0px;
    margin-top: 4px;
}
.apply{
    background-color: #36983B;
    width: 50%;    
    color: #fff;
}

.location-con{
    width: 450px;
    background-color: #FFFFFF;
    padding: 5px;
}

.query{
    width: 100%;
    height: calc(90vh);
}
.query-card_con{
    height: 78vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 40px;
}
.query-header{
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 15px;
}
.query-header-text p{
    cursor: pointer;
    margin: 0px 20px 0px 0px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #A8A8A8;
    &.active{
        color: black;
        text-decoration: underline;
        text-underline-offset: 12px;
        text-decoration-thickness: 2px;
        text-decoration-color: #1D8D56;
    }
}

.enddatetext{
       &.active{
        color: #A8A8A8;
    } 
}
.checkbox{
    margin: 0px 40px 0px 0px;
}
.addcomment-con{
    position: fixed;
    top: 18%;
    width: 40%;
    right: 3%;
    max-width: 590px;
    min-width: 300px;

    @media screen and (max-width: 1000px) {
        width: 50%;
        // left: 50%;
        right: 4%;
    }
}
.add-comment-btn{
    color: #FFFFFF;
    font-size: 0.9rem;
    font-weight: 500;
    background-color: #1D8D56;
    padding: 8px 20px;
    border-radius: 3px;
    margin-left: 30px;
    cursor: pointer;
}
.apply-btn{
    cursor: pointer;
}
// btn-text-transform	uppercase !default;
.query-header-btn{
    background-color: #EBF5F0;
    color: #1D8D56;
    font-size: .9rem;
    font-weight: 500;
    padding: 10px 14px;
    border-radius: 3px;
}

.icon{
    color: #1D8D56;
    font-size: 0.9rem;  
}

.downarrow-icon{
    color: #FFFFFF;
    font-size: 0.9rem;
}
.paginaton_con{
    position: fixed;
    bottom: 10px;
    margin: 0px auto;
    width: 78%;
    background-color: #FFFFFF;
    height: 60px;
    padding: 8px 0px;
}
.v-menu__content{
    margin-top: 9px;
    width: 400px;
    margin-left: -100px !important;
}

//scrollbar
::-webkit-scrollbar {
  width: 8px;
  margin: 3px;
  border-left: 1px solid rgba(50, 52, 65, 0.1);
  border-right: 1px solid rgba(50, 52, 65, 0.1);
  margin-left: 100px;

}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: rgba(50, 52, 65, 0.15);
//   border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  width: 8px;
}
::-webkit-scrollbar-corner {
//   display: none;
  height: 0px;
  width: 0px;
}
</style>

<style>
.filter-con .v-btn__content {
    text-transform: capitalize !important;
}
.filter-con .v-input__slot > .v-label{
    font-weight: 500 !important;
    color: #5B5B5B !important;
}

.v-input--selection-controls__ripple{
    display: none;
}

</style>